import { useEffect } from "react";

const TawkToWidget = () => {
  useEffect(() => {
    // Create the Tawk.to script element
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://embed.tawk.to/6763e21349e2fd8dfefa3291/1iff2m84d";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    
    document.body.appendChild(script);

    
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; 
};

export default TawkToWidget;
